import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationService {

  private hubConnection!: signalR.HubConnection;
  readonly serviceApi = environment.hubUrl;

  public startConnection(token: string) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.serviceApi + '/notifications', {
        accessTokenFactory: () => token,
        transport: signalR.HttpTransportType.WebSockets // ajuda com estabilidade
      })
      .withAutomaticReconnect([0, 2000, 2000, 5000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 30000]) // reconecta progressivamente
      .build();

    this.registerEvents();

    this.hubConnection
      .start()
      .then(() => console.log('✅ Conectado ao hub de notificações'))
      .catch(err => console.error('❌ Erro na conexão SignalR:', err));
  }

  private registerEvents() {
    this.hubConnection.onreconnecting(error => {
      console.warn('🔄 Reconectando...', error);
    });

    this.hubConnection.onreconnected(connectionId => {
      console.log('✅ Reconectado ao hub! ID:', connectionId);
    });

    this.hubConnection.onclose(error => {
      console.error('🚫 Conexão encerrada com erro:', error);

    });
  }

  public onMessage(callback: (msg: string) => void) {
    this.hubConnection.on('ReceiveNotification', callback);
  }
}
